import React from "react";

import { setupActions } from "../actions";
import { connect } from "react-redux";

import { Spinner } from "components/Icons/Spinner";
import { Row, Col } from "reactstrap";

var viewActions = require("store/view.actions");

class ConfigPage extends React.Component {
  componentDidMount() {
    this.props.setMainTitle("Configuración", []);
  }

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <div className="content">
          {!this.props.view.loadingModules.getStudentBrief ? (
            <Row>
              <Col md="12">
                Cambiar ciclo lectivo:
                <select
                  value={this.props.currentCalendarID}
                  onChange={(e) => {
                    setupActions.changeCurrentCalendar(e.target.value);
                  }}
                >
                  {this.props.school.calendars.map((cal) => {
                    return (
                      (cal.short_name === "2022" ||
                        cal.short_name === "2023" ||
                        cal.short_name === "2024" ||
                        cal.short_name === "2025" ||
                        cal.short_name === "2026" ||
                        cal.short_name === "2027") && (
                        <option key={cal.calendar_id} value={cal.calendar_id}>
                          {cal.name}
                        </option>
                      )
                    );
                  })}
                </select>
              </Col>
            </Row>
          ) : (
            <Spinner size="XL" />
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentCalendarID: state.school.currentCalendarID,
    view: state.view,
    school: state.config.school,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setMainTitle: (title, menu) => {
      dispatch(viewActions.setMainTitle(title, menu));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfigPage);
